import Cart from './cart'
import CancellationForm from './cancellation_form'
import CheckoutAddress from './checkout_address'
import CheckoutHotelDetails from './checkout_hotel_details'
import CheckoutAddOns from './checkout_add_on'
import CheckoutTermsAndConditions from './checkout_terms_and_conditions'
import CheckoutPayment from './checkout_payment'
import Confirmation from './confirmation'
import CreditCardForm from './credit_card_form'
import F1TvCodes from './f1_tv_codes'
import FanaticCodes from './fanatic_codes'
import FormPackage from './form_package'
import H4H from './h4h'
import MementoCodes from './memento_codes'
import NavCart from './nav_cart'
import Opportunity from './opportunity'
import Orders from './orders'
import PaymentTerms from './payment_terms'
import RoomingLists from './rooming_lists'
import ShipmentCodes from './shipment_codes'

export const messages = {
  en: {
    cart: Cart.en(),
    cancellation_form: CancellationForm.en(),
    checkout: {
      addOn: CheckoutAddOns.en(),
      address: CheckoutAddress.en(),
      hotelDetails: CheckoutHotelDetails.en(),
      docusign: CheckoutTermsAndConditions.en(),
      payment: CheckoutPayment.en(),
    },
    confirmation: Confirmation.en(),
    creditCardForm: CreditCardForm.en(),
    f1TvCodes: F1TvCodes.en(),
    fanaticCodes: FanaticCodes.en(),
    formPackage: FormPackage.en(),
    h4h: H4H.en(),
    navCart: NavCart.en(),
    orders: Orders.en(),
    opportunity: Opportunity.en(),
    paymentTerms: PaymentTerms.en(),
    roomingLists: RoomingLists.en(),
    shipmentCodes: ShipmentCodes.en(),
    topBar: {
      authentics: 'AUTHENTICS',
      store: 'STORE',
      tickets: 'TICKETS',
      hospitality: 'HOSPITALITY',
      experiences: 'EXPERIENCES',
      sign_in_register: '<i class="icon-account"></i> SIGN IN <em>OR</em> REGISTER'
    },
    cookie: {
      cookie_consent: 'We use cookies to personalize content analyze our traffic and to capture information provided by our visitors to contact them about our events and services. You consent to <a href="/cookies-policy" target="_blank">our cookies</a> if you continue to use this website.',
      cookieConsentGpeFirst: 'We use cookies. Find out more',
      cookieConsentGpeLink: 'here',
      cookieConsentGpeLast:'. By using the site you accept the policy.',
      continue: 'Continue'
    },
    allPurchases: '*All purchases will process in USD',
    creditCardNumber: 'Credit Card Number',
    currencyDisclaimer: '*Purchases in the selected currency will process in USD. Currency amount is an estimate based on current exchange rates. Since processing in USD, your bank could charge you additional fees.',
    currencyDisclaimerCharge: '*Payment will be processed in currency selected. Based on current exchange rates, converted from USD',
    cVV: 'CVV',
    dueDate: 'due {date}',
    expirationDate: 'Expiration Date (mm / yy)',
    forgotYourPassword: 'Forgot your password?',
    form: {
      comments: 'Comments',
      company_name: 'Company Name',
      corporate: 'Is this request for a corporate group?',
      email: 'Email',
      event: 'Event',
      first_name: 'First Name',
      how_many: 'Number of travelers',
      last_name: 'Last Name',
      marketing_email_consent: 'I agree to our <a href=\'/privacy-policy\' target=\'/blank\'>privacy policy</a> and to be contacted regarding my selected event.',
      nba_marketing_email_consent: 'I agree to the <a href=\'http://www.nba.com/news/privacy_policy.html\' target=\'/blank\'>NBA Privacy Policy</a>. I agree to have my personal information transferred to NBA Properties, Inc. (”NBAP”).',
      nba_partners_consent: 'Please share my personal information with Partners and affiliates of the NBA, so that they can also contact me about their products entity and services that might be of interest to me.',
      nba_privacy_policy_consent: 'Do you you agree to the <a href=\'https://www.nba.com/news/termsofuse/\' target=\'/blank\'>NBA Terms of Use</a> and <a href=\'http://www.nba.com/news/privacy_policy.html\' target=\'/blank\'>NBA Privacy Policy</a>. I agree to have my personal information transferred to NBA Properties, Inc. (”NBAP”).',
      nba_products_services_consent: 'Please use my personal information to send me messages and deliver ads about NBA related products and services.',
      next: 'Next',
      password: 'Password',
      password_confirmation: 'Password confirmation',
      phone: 'Phone',
      reseller_checkbox: 'Are you a Travel Adviser/Reseller?',
      sign_up_for_nba_info: 'Sign Up For NBA Info',
      submit: 'Submit'
    },
    logIn: 'Log In',
    logInOrSignUp: 'Log In or Sign Up to Continue',
    messages: {
      close: 'Close',
      questions: 'If you have immediate questions or concerns, please call',
      required: 'This field is required',
      sent_to_email: 'Your inquiry has been forwarded to a {brand_name} representative who will be in touch soon! A confirmation will be sent to your email, {email}.',
      thank_you: 'Thank You!'
    },
    mementoCodes: MementoCodes.en(),
    noHotel: 'No Hotel',
    noPackage: 'No Package',
    packageNotUpdated: 'Package was not able to update',
    passwordComplexity: 'Password must include at least one lowercase letter, one uppercase letter, one special character and one digit',
    payment_term_1: 'Pay in Full Today',
    payment_term_2: 'Pay 50% today and 50% later',
    payment_term_3: 'Pay 1/3 today and 2 more payments later',
    pleaseReview: 'Please review the following fields:',
    remove: 'Remove',
    request_packages: 'Request Information Below',
    required: 'This field is required',
    roomQtyError: 'The number of rooms may not exceed the number of packages',
    rejectRoomQuantity: 'The number of rooms may not exceed the number of packages.',
    rejectCountry: 'Country is not permitted.',
    signUp: 'Sign up',
    sorryWeCouldNot: 'Sorry, we could not process your order. Please contact us if the problem continues.',
    submitFormError: 'Sorry, we could not submit your request.  Please try again later',
    taxDisclaimer: 'Amount includes all applicable transaction taxes',
    today: 'Today'
  },
  'en-GB': {
    cart: Cart.enGB(),
    cancellation_form: CancellationForm.enGB(),
    checkout: {
      addOn: CheckoutAddOns.enGB(),
      address: CheckoutAddress.enGB(),
      hotelDetails: CheckoutHotelDetails.enGB(),
      docusign: CheckoutTermsAndConditions.enGB(),
      payment: CheckoutPayment.enGB(),
    },
    confirmation: Confirmation.enGB(),
    creditCardForm: CreditCardForm.enGB(),
    f1TvCodes: F1TvCodes.enGB(),
    fanaticCodes: FanaticCodes.enGB(),
    formPackage: FormPackage.enGB(),
    h4h: H4H.enGB(),
    navCart: NavCart.enGB(),
    orders: Orders.enGB(),
    opportunity: Opportunity.enGB(),
    paymentTerms: PaymentTerms.enGB(),
    roomingLists: RoomingLists.enGB(),
    shipmentCodes: ShipmentCodes.enGB(),
    topBar: {
      authentics: 'AUTHENTICS',
      store: 'STORE',
      tickets: 'TICKETS',
      hospitality: 'HOSPITALITY',
      experiences: 'EXPERIENCES',
      sign_in_register: '<i class="icon-account"></i> SIGN IN <em>OR</em> REGISTER'
    },
    cookie: {
      cookie_consent: 'We use cookies to personalize content analyze our traffic and to capture information provided by our visitors to contact them about our events and services. You consent to <a href="/cookies-policy" target="_blank">our cookies</a> if you continue to use this website.',
      cookieConsentGpeFirst: 'We use cookies. Find out more',
      cookieConsentGpeLink: 'here',
      cookieConsentGpeLast:'. By using the site you accept the policy.',
      continue: 'Continue'
    },
    allPurchases: '*All purchases will process in USD',
    creditCardNumber: 'Credit Card Number',
    currencyDisclaimer: '*Purchases in the selected currency will process in USD. Currency amount is an estimate based on current exchange rates. Since processing in USD, your bank could charge you additional fees.',
    currencyDisclaimerCharge: '*Payment will be processed in currency selected. Based on current exchange rates, converted from USD',
    cVV: 'CVV',
    dueDate: 'due {date}',
    expirationDate: 'Expiration Date (mm / yy)',
    forgotYourPassword: 'Forgot your password?',
    form: {
      comments: 'Comments',
      company_name: 'Company Name',
      corporate: 'Is this request for a corporate group?',
      email: 'Email',
      event: 'Event',
      first_name: 'First Name',
      how_many: 'Number of travelers',
      last_name: 'Last Name',
      marketing_email_consent: 'I agree to our <a href=\'/privacy-policy\' target=\'/blank\'>privacy policy</a> and to be contacted regarding my selected event.',
      nba_marketing_email_consent: 'I agree to the <a href=\'http://www.nba.com/news/privacy_policy.html\' target=\'/blank\'>NBA Privacy Policy</a>. I agree to have my personal information transferred to NBA Properties, Inc. (”NBAP”).',
      nba_partners_consent: 'Please share my personal information with Partners and affiliates of the NBA, so that they can also contact me about their products entity and services that might be of interest to me.',
      nba_privacy_policy_consent: 'Do you you agree to the <a href=\'https://www.nba.com/news/termsofuse/\' target=\'/blank\'>NBA Terms of Use</a> and <a href=\'http://www.nba.com/news/privacy_policy.html\' target=\'/blank\'>NBA Privacy Policy</a>. I agree to have my personal information transferred to NBA Properties, Inc. (”NBAP”).',
      nba_products_services_consent: 'Please use my personal information to send me messages and deliver ads about NBA related products and services.',
      next: 'Next',
      password: 'Password',
      password_confirmation: 'Password confirmation',
      phone: 'Phone',
      reseller_checkbox: 'Are you a Travel Adviser/Reseller?',
      sign_up_for_nba_info: 'Sign Up For NBA Info',
      submit: 'Submit'
    },
    logIn: 'Log In',
    logInOrSignUp: 'Log In or Sign Up to Continue',
    messages: {
      close: 'Close',
      questions: 'If you have immediate questions or concerns, please call',
      required: 'This field is required',
      sent_to_email: 'Your inquiry has been forwarded to a {brand_name} representative who will be in touch soon! A confirmation will be sent to your email, {email}.',
      thank_you: 'Thank You!'
    },
    mementoCodes: MementoCodes.enGB(),
    noHotel: 'No Accommodation',
    noPackage: 'No Package',
    packageNotUpdated: 'Package was not able to update',
    passwordComplexity: 'Password must include at least one lowercase letter, one uppercase letter, one special character and one digit',
    payment_term_1: 'Pay in Full Today',
    payment_term_2: 'Pay 50% today and 50% later',
    payment_term_3: 'Pay 1/3 today and 2 more payments later',
    pleaseReview: 'Please review the following fields:',
    remove: 'Remove',
    request_packages: 'Request Information Below',
    required: 'This field is required',
    roomQtyError: 'The number of rooms may not exceed the number of packages',
    rejectRoomQuantity: 'The number of rooms may not exceed the number of packages.',
    rejectCountry: 'Country is not permitted.',
    signUp: 'Sign up',
    sorryWeCouldNot: 'Sorry, we could not process your order. Please contact us if the problem continues.',
    submitFormError: 'Sorry, we could not submit your request.  Please try again later',
    taxDisclaimer: 'Amount includes all applicable transaction taxes',
    today: 'Today'
  },
  'es-MX': {
    cart: Cart.esMX(),
    cancellation_form: CancellationForm.esMX(),
    checkout: {
      addOn: CheckoutAddOns.esMX(),
      address: CheckoutAddress.esMX(),
      hotelDetails: CheckoutHotelDetails.esMX(),
      docusign: CheckoutTermsAndConditions.esMX(),
      payment: CheckoutPayment.esMX(),
    },
    confirmation: Confirmation.esMX(),
    creditCardForm: CreditCardForm.esMX(),
    f1TvCodes: F1TvCodes.esMX(),
    fanaticCodes: FanaticCodes.esMX(),
    formPackage: FormPackage.esMX(),
    h4h: H4H.esMX(),
    navCart: NavCart.esMX(),
    orders: Orders.esMX(),
    opportunity: Opportunity.esMX(),
    paymentTerms: PaymentTerms.esMX(),
    roomingLists: RoomingLists.esMX(),
    shipmentCodes: ShipmentCodes.esMX(),
    topBar: {
      authentics: 'AUTHENTICS',
      store: 'STORE',
      tickets: 'BOLETOS',
      hospitality: 'HOSPITALIDAD',
      experiences: 'EXPERIENCES',
      sign_in_register: '<i class="icon-account"></i> INGRESAR <em>O</em> REGISTRARSE'
    },
    cookie: {
      cookie_consent: 'Usamos cookies para personalizar el contenido, analizar nuestro tráfico y capturar la información proporcionada por nuestros visitantes para contactarlos en relación a nuestros eventos y servicios. Usted acepta <a href="/cookies-policy" target="_blank">nuestras cookies</a> si continúa usando este sitio web.',
      continue: 'Continuar'
    },
    allPurchases: '*Todas las compras se procesarán en USD',
    creditCardNumber: 'Número de Tarjeta de Crédito',
    currencyDisclaimer: '*Las compras en la moneda seleccionada se procesarán en USD. Monto de la moneda es una estimación basada en las tasas de cambio actuales. Desde el procesamiento en USD, su banco podría cobrarle tarifas adicionales.',
    currencyDisclaimerCharge: '*El pago se procesará en la moneda seleccionada. La cantidad se basa en los tipos de cambio actuales, convertidos de USD.',
    cVV: 'CVV',
    dueDate: 'a pagar {date}',
    expirationDate: 'Fecha de Expiración (mm / aa)',
    forgotYourPassword: '¿Olvidó su contraseña?',
    form: {
      comments: 'Comentarios',
      company_name: 'Company Name',
      corporate: '¿Esta solicitud es para un grupo corporativo?',
      email: 'Correo electrónico',
      event: 'Evento',
      first_name: 'Nombre',
      how_many: 'Número de Viajeros',
      last_name: 'Apellido',
      marketing_email_consent: 'Acepto la <a href="/privacy-policy" target="/blank">política de privacidad</a> y a ser contactado en relación a mi evento seleccionado.',
      next: 'Siguiente',
      password: 'Contraseña',
      password_confirmation: 'confirmación de contraseña',
      phone: 'Teléfono',
      reseller_checkbox: '¿Es usted un Agente de Viajes/Revendedor?',
      submit: 'Enviar'
    },
    logIn: 'Entrar',
    logInOrSignUp: 'Inicie Sesión o Regístrese para Continuar',
    messages: {
      close: 'Cerrar',
      questions: 'Si tiene preguntas o dudas inmediatas, favor de llamarnos',
      required: 'Necesario',
      sent_to_email: '¡Su solicitud ha sido enviada a un representante de %{brand_name} que se pondrá en contacto pronto! Una confirmación ha sido enviada a su correo %{email}.',
      thank_you: 'Thank You!'
    },
    mementoCodes: MementoCodes.esMX(),
    noHotel: 'Sin Hotel',
    noPackage: 'Sin Paquete',
    packageNotUpdated: 'Paquete no pudo actualizarse',
    passwordComplexity: 'La contraseña debe incluir por lo menos una letra minúscula, una mayúscula, un símbolo especial y un dígito.',
    payment_term_1: 'Realice el Pago Total Hoy',
    payment_term_2: 'Realice un Pago por el 50% y pague el 50% restante después',
    payment_term_3: 'Realice un Pago por 1/3 y haga dos pagos más después',
    pleaseReview: 'Please review the following fields:',
    remove: 'Eliminar',
    request_packages: 'Solicitar Información Abajo',
    required: 'Necesario',
    roomQtyError: 'El número de habitaciones no puede exceder el número de paquetes',
    rejectRoomQuantity: 'El número de habitaciones no puede exceder el número de paquetes',
    rejectCountry: 'El país no está permitido',
    signUp: 'registrarse',
    sorryWeCouldNot: 'Lo sentimos, no podemos procesar su orden. Favor de contactarnos si el problema continúa.',
    submitFormError: 'Lo sentimos, no pudimos enviar su solicitud. Favor de intentar nuevamente más tarde.',
    taxDisclaimer: 'El monto incluye todos los impuestos de transacción aplicables',
    today: 'Hoy'
  },
  fr: {
    cart: Cart.fr(),
    cancellation_form: CancellationForm.fr(),
    checkout: {
      addOn: CheckoutAddOns.fr(),
      address: CheckoutAddress.fr(),
      hotelDetails: CheckoutHotelDetails.fr(),
      docusign: CheckoutTermsAndConditions.fr(),
      payment: CheckoutPayment.fr(),
    },
    confirmation: Confirmation.fr(),
    creditCardForm: CreditCardForm.fr(),
    f1TvCodes: F1TvCodes.fr(),
    fanaticCodes: FanaticCodes.fr(),
    formPackage: FormPackage.fr(),
    h4h: H4H.fr(),
    navCart: NavCart.fr(),
    orders: Orders.fr(),
    opportunity: Opportunity.fr(),
    paymentTerms: PaymentTerms.fr(),
    roomingLists: RoomingLists.fr(),
    shipmentCodes: ShipmentCodes.fr(),
    topBar: {
      authentics: 'AUTHENTICS',
      store: 'STORE',
      tickets: 'TICKETS',
      hospitality: 'SERVICE D`ACCUEIL',
      experiences: 'EXPERIENCES',
      sign_in_register: '<i class="icon-account"></i> SE CONNECTER <em>OU</em> S`INSCRIRE'
    },
    cookie: {
      cookie_consent: 'Nous utilisons des cookies pour personnaliser nos contenus, analyser notre traffic, et collecter les informations fournis par nos visiteurs afin de les contacter à propos de nos événements et nos services. En continuant à utiliser notre site web, vous acceptez  <a href="/cookies-policy" target="_blank">notre utilisation des cookies/a>.',
      continue: 'Continuer'
    },
    allPurchases: '*Tous les achats seront traités en USD',
    creditCardNumber: 'Numéro de carte de crédit',
    currencyDisclaimer: '*Les achats effectués dans la devise sélectionnée seront traités en USD. Le montant indiqué dans cette devise est une estimation basée sur le taux de change actuel. Etant donné que votre achat sera traité en USD, votre banque peut vous facturer des frais supplémentaires.',
    currencyDisclaimerCharge: '*Le paiement sera traité dans la devise sélectionnée. Basé sur les taux de change actuels, convertis à partir du dollar US.',
    cVV: 'CVV',
    dueDate: 'dû le {date}',
    expirationDate: 'Date d`expiration (mois/année)',
    forgotYourPassword: 'Mot de passe oublié ?',
    form: {
      comments: 'Commentaires',
      company_name: 'Nom de la société',
      corporate: 'Votre requête concerne-t-elle un Forfait Entreprise ?',
      email: 'Adresse courriel',
      event: 'Évènement',
      first_name: 'Prénom',
      how_many: 'Nombre de voyageurs',
      last_name: 'Nom de famille',
      marketing_email_consent: 'J\'accepte votre <a href="/privacy-policy" target="/blank">politique de confidentialité</a>, et d\'être contacté à propos de l\'événement que j\'ai choisi.',
      next: 'Suivant',
      password: 'Mot de passe',
      password_confirmation: 'Confirmation mot de passe',
      phone: 'Téléphone',
      reseller_checkbox: 'Êtes-vous un agent/une agence de voyage ?',
      submit: 'Soumettre'
    },
    logIn: 'Se connecter',
    logInOrSignUp: 'Connectez-vous ou inscrivez-vous pour continuer.',
    messages: {
      close: 'Fermer',
      questions: 'Si vous avez des questions ou des préoccupations immédiates, veuillez nous appeler',
      required: 'Champs obligatoires',
      sent_to_email: 'Votre requête a été envoyée à un représentant de %{brand_name} qui vous contactera dans les plus brefs délais ! Une confirmation vous a été envoyée à votre adresse courriel %{email}.',
      thank_you: 'Thank You!'
    },
    mementoCodes: MementoCodes.fr(),
    noHotel: 'Aucun hôtel',
    noPackage: 'Aucun forfait',
    packageNotUpdated: 'Impossibilité de mettre à jour le forfait',
    passwordComplexity: 'Le mot de passe doit inclure au moins une lettre minuscule, une lettre majuscule, un caractère spécial et un chiffre.',
    payment_term_1: 'Payer le total aujourd\'hui',
    payment_term_2: 'Payer 50% aujourd\'hui et 50% plus tard',
    payment_term_3: 'Payer 1/3 aujourd\'hui et 2 autres paiements plus tard',
    pleaseReview: 'Veuillez vérifier les champs suivants:',
    remove: 'Retirer',
    request_packages: 'Demande d`information',
    required: 'Champs obligatoires',
    roomQtyError: 'Le nombre de chambres ne peut excéder le nombre de forfaits',
    rejectRoomQuantity: 'Le nombre de chambres ne peut dépasser le nombre de colis',
    rejectCountry: 'Le pays n\'est pas autorisé',
    signUp: 's\'inscrire',
    sorryWeCouldNot: 'Désolé, nous n\'avons pas pu traiter votre commande. Si le problème persiste, veuillez nous conctacter.',
    submitFormError: 'Désolée, nous n\'avons pas pu soumettre votre requête. Veuillez réessayer plus tard.',
    taxDisclaimer: 'Le montant inclut toutes les taxes de transaction applicables',
    today: 'Aujourd\'hui'
  },
  it: {
    cart: Cart.it(),
    cancellation_form: CancellationForm.it(),
    checkout: {
      addOn: CheckoutAddOns.it(),
      address: CheckoutAddress.it(),
      hotelDetails: CheckoutHotelDetails.it(),
      docusign: CheckoutTermsAndConditions.it(),
      payment: CheckoutPayment.it(),
    },
    confirmation: Confirmation.it(),
    creditCardForm: CreditCardForm.it(),
    f1TvCodes: F1TvCodes.it(),
    fanaticCodes: FanaticCodes.it(),
    formPackage: FormPackage.it(),
    h4h: H4H.it(),
    navCart: NavCart.it(),
    orders: Orders.it(),
    opportunity: Opportunity.it(),
    paymentTerms: PaymentTerms.it(),
    roomingLists: RoomingLists.it(),
    shipmentCodes: ShipmentCodes.it(),
    topBar: {
      authentics: 'AUTHENTICS',
      store: 'STORE',
      tickets: 'BIGLIETTI',
      hospitality: 'ACCOGLIENZA',
      experiences: 'EXPERIENCES',
      sign_in_register: '<i class="icon-account"></i> ACCEDI <em>O</em> REGISTRATI'
    },
    cookie: {
      cookie_consent: 'Utilizziamo i cookie per personalizzare i contenuti, per analizzare il traffico e per raccogliere le informazioni fornite da quei visitatori che desiderino essere contatti per ricevere ulteriori dettagli riguardo i nostri servizi e i nostri eventi. L&#39utente dà il proprio consenso all&#39utilizzo di <a href="/cookies-policy" target="_blank">cookie</a> da parte nostra nel momento stesso in cui continua a utilizzare questo sito.',
      continue: 'Continua'
    },
    allPurchases: '*Tutti gli acquisti verranno elaborati in dollari statunitensi',
    creditCardNumber: 'Numero di carta di credito',
    currencyDisclaimer: '*Gli acquisti nella valuta selezionata verranno elaborati in USD. L\'importo in valuta è una stima basata sui tassi di cambio correnti. Dall\'elaborazione in USD, la tua banca potrebbe addebitare commissioni aggiuntive.',
    currencyDisclaimerCharge: '*Il pagamento sarà elaborato nella valuta selezionata. L\'importo si basa sui tassi di cambio correnti, con conversione a partire dai dollari statunitensi.',
    cVV: 'CVV',
    dueDate: 'scadenza {date}',
    expirationDate: 'Data di scadenza (MM/YY)',
    forgotYourPassword: 'Hai dimenticato la tua password?',
    form: {
      comments: 'Commenti',
      company_name: 'Company Name',
      corporate: 'La tua richiesta riguarda un gruppo aziendale?',
      email: 'Indirizzo e-mail',
      event: 'Evento',
      first_name: 'Nome',
      how_many: 'Numero di partecipanti',
      last_name: 'Cognome',
      marketing_email_consent: 'Accetto <a href="/privacy-policy" target="/blank">l\'Informativa sulla privacy</a> e di essere ricontattato in merito all\'evento selezionato',
      next: 'Il prossimo',
      password: 'Parola d\'ordine',
      password_confirmation: 'conferma password',
      phone: 'Telefono',
      reseller_checkbox: 'Sei un consulente di viaggio o rivenditore?',
      submit: 'Invia'
    },
    logIn: 'Accedi',
    logInOrSignUp: 'Accedi o iscriviti per continuare',
    messages: {
      close: 'Chiudi',
      questions: 'Se hai domande o dubbi urgenti, contattaci pure telefonicamente',
      required: 'necessario',
      sent_to_email: 'La tua richiesta è stata inviata a un addetto di %{brand_name} che si metterà in contatto con te al più presto! Abbiamo inviato una conferma al tuo indirizzo email %{email}.',
      thank_you: 'Thank You!'
    },
    mementoCodes: MementoCodes.it(),
    noHotel: 'Nessun albergo',
    noPackage: 'Nessun pacchetto',
    packageNotUpdated: 'Non è stato possibile aggiornare il pacchetto',
    passwordComplexity: 'La password deve includere almeno una lettera minuscola, una lettera maiuscola, un carattere speciale e un numero',
    payment_term_1: 'Paga tutto subito',
    payment_term_2: 'Paga il 50% subito e il 50% in un secondo momento',
    payment_term_3: 'Paga un terzo dell\'importo subito e il restante in due tranche successive',
    pleaseReview: 'Si prega di rivedere i seguenti campi:',
    remove: 'Rimuovi',
    request_packages: 'Richiedi informazioni qui sotto',
    required: 'necessario',
    roomQtyError: 'Il numero di camere non può superare il numero di pacchetti',
    rejectRoomQuantity: 'Il numero di camere non può superare il numero di pacchi',
    rejectCountry: 'Il Paese non è permesso',
    signUp: 'Iscriviti',
    sorryWeCouldNot: 'Ci dispiace, ma non è stato possibile elaborare il tuo ordine. Ti preghiamo di contattarci nel caso in cui il problema dovesse persistere.',
    submitFormError: 'Ci dispiace, ma non ci è stato possibile inviare la tua richiesta. Per favore riprova più tardi.',
    taxDisclaimer: 'L\'importo include tutte le tasse applicabili',
    today: 'Oggi'
  },
  de: {
    cart: Cart.de(),
    cancellation_form: CancellationForm.de(),
    checkout: {
      addOn: CheckoutAddOns.de(),
      address: CheckoutAddress.de(),
      hotelDetails: CheckoutHotelDetails.de(),
      docusign: CheckoutTermsAndConditions.de(),
      payment: CheckoutPayment.de(),
    },
    confirmation: Confirmation.de(),
    creditCardForm: CreditCardForm.de(),
    f1TvCodes: F1TvCodes.de(),
    fanaticCodes: FanaticCodes.de(),
    formPackage: FormPackage.de(),
    h4h: H4H.de(),
    navCart: NavCart.de(),
    orders: Orders.de(),
    opportunity: Opportunity.de(),
    paymentTerms: PaymentTerms.de(),
    roomingLists: RoomingLists.de(),
    shipmentCodes: ShipmentCodes.de(),
    topBar: {
      authentics: 'AUTHENTICS',
      store: 'STORE',
      tickets: 'TICKETS',
      hospitality: 'HOSPITALITY',
      experiences: 'EXPERIENCES',
      sign_in_register: '<i class="icon-account"></i> ANMELDEN <em>ODER</em> REGISTRIEREN'
    },
    cookie: {
      cookie_consent: 'Wir verwenden Cookies, um Inhalte zu personalisieren, unseren Traffic zu analysieren und Informationen zu erfassen, die von unseren Besuchern zur Verfügung gestellt werden, um sie über unsere Veranstaltungen und Dienstleistungen zu informieren. Sie stimmen der Verwendung von <a href="/cookies-policy" target="_blank">unseren Cookies</a> zu, wenn Sie diese Webseite weiter nutzen.\r\n',
      continue: 'Fortfahren'
    },
    allPurchases: '*Alle Einkäufe werden in USD verarbeitet',
    creditCardNumber: 'Kreditkartennummer',
    currencyDisclaimer: '*Einkäufe in der ausgewählten Währung werden in USD abgewickelt. Der Währungsbetrag ist eine Schätzung, die auf aktuellen Wechselkursen basiert. Seit der Bearbeitung in USD kann Ihre Bank zusätzliche Gebühren in Rechnung stellen.',
    currencyDisclaimerCharge: '*Zahlungen werden in der ausgewählen Währung verarbeitet. Der Betrag basiert auf den aktuellen Wechselkursen, umgerechnet von USD',
    cVV: 'Kartenprüfnummer (CVV)',
    dueDate: 'Fällig am {date}',
    expirationDate: 'Verfalldatum (MM/JJ)',
    forgotYourPassword: 'Passwort vergessen?',
    form: {
      comments: 'Kommentare',
      company_name: 'Firmenname',
      corporate: 'Ist diese Anfrage für ein Unternehmen?',
      email: 'E-Mail',
      event: 'Veranstaltung',
      first_name: 'Vorname',
      how_many: 'Anzahl Reisende',
      last_name: 'Nachname',
      marketing_email_consent: 'Ich stimme den <a href="/privacy-policy" target="/blank">Datenschutzbestimmungen</a> zu und erkläre mich damit einverstanden, bezüglich meiner ausgewählten Veranstaltungen kontaktiert zu werden',
      next: 'Nächster',
      password: 'Passwort',
      password_confirmation: 'Passwort Bestätigung',
      phone: 'Telefon',
      reseller_checkbox: 'Sind Sie ein Reiseberater / Wiederverkäufer?',
      submit: 'Abschicken'
    },
    logIn: 'Anmelden',
    logInOrSignUp: 'Melden Sie sich an oder Registrieren Sie sich um weiterzufahren',
    messages: {
      close: 'Schließen',
      questions: 'Falls Sie dringende Fragen oder Anliegen haben, rufen Sie uns bitte an',
      required: 'Erforderlich',
      sent_to_email: 'Ihre Anfrage wurde an einen %{brand_name} Repräsentanten weitergeleitet und Sie werden in Kürze kontaktiert! Eine Bestätigung wurde an Ihre E-Mail-Adresse %{email} geschickt.',
      thank_you: 'Thank You!'
    },
    mementoCodes: MementoCodes.de(),
    noHotel: 'Kein Hotel',
    noPackage: 'Kein Paket',
    packageNotUpdated: 'Das Paket kann nicht aktualisiert werden',
    passwordComplexity: 'Das Passwort muss mindestens einen Großbuchstaben, einen Kleinbuchstaben, ein Sonderzeichen und eine Zahl beinhalten.',
    payment_term_1: 'Heute den Gesamtbetrag bezahlen',
    payment_term_2: 'Bezahlen Sie 50% heute und 50% später',
    payment_term_3: 'Bezahlen Sie heute 1/3 und 2 weitere Zahlungen später',
    pleaseReview: 'Bitte überprüfen Sie die folgenden Felder:',
    remove: 'Entfernen',
    request_packages: 'Informationen unten anfordern',
    required: 'Erforderlich',
    roomQtyError: 'Die Anzahl der Zimmer darf die Anzahl der Pakete nicht überschreiten',
    rejectRoomQuantity: 'Die Anzahl der Räume darf die Anzahl der Pakete nicht überschreiten',
    rejectCountry: 'Land ist nicht erlaubt',
    signUp: 'Anmelden',
    sorryWeCouldNot: 'Es tut uns leid, aber wir können mit Ihrer Bestellung nicht weiterfahren. Bitte kontaktieren Sie uns, falls das Problem weiter besteht.',
    submitFormError: 'Es tut uns leid, wir konnten Ihre Anfrage nicht übermitteln. Bitte versuchen Sie es später noch einmal.',
    taxDisclaimer: 'Der Betrag beinhaltet alle anfallenden Transaktionsgebühren',
    today: 'Heute'
  },
  ar: {
    cart: Cart.ar(),
    cancellation_form: CancellationForm.ar(),
    checkout: {
      addOn: CheckoutAddOns.ar(),
      address: CheckoutAddress.ar(),
      hotelDetails: CheckoutHotelDetails.ar(),
      docusign: CheckoutTermsAndConditions.ar(),
      payment: CheckoutPayment.ar(),
    },
    confirmation: Confirmation.ar(),
    creditCardForm: CreditCardForm.ar(),
    f1TvCodes: F1TvCodes.ar(),
    fanaticCodes: FanaticCodes.ar(),
    formPackage: FormPackage.ar(),
    h4h: H4H.ar(),
    navCart: NavCart.ar(),
    orders: Orders.ar(),
    opportunity: Opportunity.ar(),
    paymentTerms: PaymentTerms.ar(),
    roomingLists: RoomingLists.ar(),
    shipmentCodes: ShipmentCodes.ar(),
    topBar: {
      authentics: 'AUTHENTICS',
      store: 'STORE',
      tickets: 'التذاكر',
      hospitality: 'الاستضافة',
      experiences: 'اكسبيرينس',
      sign_in_register: '<i class="icon-account"></i> سجل الدخول <em>او</em> قم بتسجيل حساب جديد'
    },
    cookie: {
      cookie_consent: 'نستخدم ملفات تعريف الارتباط لتخصيص المحتوى وتحليل الزيارات لموقعنا ولجمع المعلومات التي يوفرها زوارنا للاتصال بهم حول الفعاليات والخدمات التي نقدمها. انت توافق على <a href="/cookies-policy" target="_blank">ملفات تعريف الإرتباط الخاصة بنا</a> و ذلك بإستخدامك لهذا الموقع.',
      continue: 'الإستمرار'
    },
    allPurchases: '*كل المعاملات المالية تتم بالدولار الامريكي',
    creditCardNumber: 'رقم البطاقة الائتمانية',
    currencyDisclaimer: 'ستتم معالجة عمليات الشراء بالعملة المحددة بالدولار الأمريكي. مبلغ العملة هو تقدير يعتمد على أسعار الصرف الحالية. منذ المعالجة بالدولار الأمريكي ، قد يفرض عليك المصرف الذي تتعامل معه رسومًا إضافية.',
    currencyDisclaimerCharge: 'سوف يتم الدفع بالعملة المختارة. بناء على معدلات تداول العملات, سوف يتم تحويلها الى الدولار الامريكي.',
    cVV: 'رقم CCV',
    dueDate: ' حتي تاريخ {date}',
    expirationDate: 'تاريخ الانتهاء (شهر/سنة)',
    forgotYourPassword: 'هل نسيت كلمة السر ؟',
    form: {
      comments: 'تعليقات',
      company_name: 'إسم الشركة',
      corporate: 'هل طلبك خاص بمجموعة شركاء؟',
      email: 'البريد الاليكتروني',
      event: 'احداث',
      first_name: 'الاسم الاول',
      how_many: 'عدد المسافرين',
      last_name: 'الاسم الاخير',
      marketing_email_consent: 'أنا اوافق على <a href="/privacy-policy" target="/blank">سياسة الخصوصية</a> وأن يتم الاتصال بي بشأن الحدث أو الفعالية التي أخترتها.',
      next: 'التالي',
      password: 'كلمة السر',
      password_confirmation: 'تأكيد كلمة السر',
      phone: 'الرقم',
      submit: 'ادراج'
    },
    logIn: 'تسجيل الدخول',
    logInOrSignUp: 'قم بتسجيل الدخول أو تسجيل حساب جديد للإستمرار',
    messages: {
      close:'غلق',
      questions:'اذا كان لديك اي استفسارات او تساؤلات, من فضلك قم بالاتصال بنا',
      required: 'هذه الخانة مطلوبه',
      send_to_email: ' لقد تم إرسال الإستفسار الخاص بك إلي ممثل %{brand_name} و سوف يقوم بالتواصل معك عما قريب! و لقد تم إرسال رسالة تأكيد على بريدك الإليكتروني %{email}.',
      thank_you: 'Thank You!'
    },
    mementoCodes: MementoCodes.ar(),
    noHotel: 'لا يوجد فنادق',
    noPackage: 'لا يوجد صفقة',
    packageNotUpdated: ' لم يتم تحديث الصفقة',
    passwordComplexity: 'يجب أن تتضمن كلمة المرور حرفًا صغيرًا واحدًا على الأقل وحرفًا واحدًا كبيرًا وحرفًا خاصًا ورقمًا واحدًا',
    payment_term_1: 'الدفع كاملا اليوم',
    payment_term_2: 'دفع 50% اليوم و 50% لاحقا',
    payment_term_3: 'دفع 1/3 المبلغ اليوم عمل دفعتين لاحقا',
    pleaseReview: 'من فضلك قم بمراجعة الحقول الآتية:',
    remove: ' ازالة',
    request_packages: 'معلومات الطلب بالاسفل',
    required: 'هذه الخانة مطلوبه',
    roomQtyError: ' لا يمكن لعدد الغرف ان يتعدي عدد الصفقات',
    rejectRoomQuantity: ' لا يمكن لعدد الغرف ان يتعدي عدد الصفقات',
    rejectCountry: 'الدولة غير مسموح بها',
    signUp: 'التسجيل',
    sorryWeCouldNot: 'نحن نأسف على عدم استكمال طلبكم. من فضلك قم بالتواصل معنا اذا استمرت المشكلة بالحدوث معك.',
    submitFormError: 'نأسف لعدم إدراج طلبك، يرجي المحاولة في وقت لاحق',
    today: 'اليوم'
  },
  ja: {
    cart: Cart.ja(),
    cancellation_form: CancellationForm.ja(),
    checkout: {
      addOn: CheckoutAddOns.ja(),
      address: CheckoutAddress.ja(),
      hotelDetails: CheckoutHotelDetails.ja(),
      docusign: CheckoutTermsAndConditions.ja(),
      payment: CheckoutPayment.ja(),
    },
    confirmation: Confirmation.ja(),
    creditCardForm: CreditCardForm.ja(),
    f1TvCodes: F1TvCodes.ja(),
    fanaticCodes: FanaticCodes.ja(),
    formPackage: FormPackage.ja(),
    h4h: H4H.ja(),
    navCart: NavCart.ja(),
    orders: Orders.ja(),
    opportunity: Opportunity.ja(),
    paymentTerms: PaymentTerms.ja(),
    roomingLists: RoomingLists.ja(),
    shipmentCodes: ShipmentCodes.ja(),
    topBar: {
      authentics: 'AUTHENTICS',
      store: 'STORE',
      tickets: 'チケット',
      hospitality: 'ホスピタリティ',
      experiences: 'エクスペリエンス',
      sign_in_register: '<i class="icon-account"></i> サインイン <em>または</em> 登録'
    },
    cookie: {
      cookie_consent: '当ウェブサイトでは、コンテンツのパーソナライズとデータトラフィック解析を行う目的およびサイト訪問者より提供された情報を取得し当社サービスおよびイベントについて訪問者に連絡する目的でクッキーを使用しています。当ウェブサイトを引き続きご利用いただくことにより、あなたは当ウェブサイトの<a href="/cookies-policy" target="_blank">クッキーに関する方針に</a> 同意するものとします。',
      continue: '続行'
    },
    allPurchases: '*すべてのご購入のお支払いは米ドルで決済されます。',
    creditCardNumber: 'クレジットカード番号',
    currencyDisclaimer: '選択した通貨での購入はUSD単位で処理されます。通貨額は、現在の為替レートに基づく見積りです。 USDでの処理以降、銀行は追加料金を請求する可能性があります。',
    currencyDisclaimerCharge: '*お支払いは選択された通貨で決済されます。現在の為替レートに基づく米ドルからの換算額になります。',
    cVV: 'CVV（セキュリティコード）',
    dueDate: '支払い期日 {date}',
    expirationDate: '有効期限（月／年）',
    forgotYourPassword: 'パスワードをお忘れですか？',
    form: {
      comments: 'コメント',
      company_name: '企業名',
      corporate: 'このリクエストは法人での利用です。',
      email: 'メール',
      event: 'イベント',
      first_name: '名',
      how_many: '旅行人数',
      last_name: '姓',
      marketing_email_consent: '当社プライバシー・ポリシーに同意し、選択したイベントについて連絡を受けることに同意します。',
      next: '次へ',
      password: 'パスワード',
      password_confirmation: 'パスワードを確認',
      phone: '電話番号',
      submit: '送信'
    },
    logIn: 'ログイン',
    logInOrSignUp: '続けるにはログインまたは登録してください',
    messages: {
      close: '閉じる',
      questions: 'お急ぎのご質問・ご用件はこちらまでお電話ください。',
      required: '入力必須項目です',
      sent_to_email: 'お客様のお問い合わせは%{brand_name} 担当者に送信されました。担当者より折り返しご連絡差し上げますので今しばらくお待ちください。お問い合わせ受付確認メールをお客様のメールアドレス %{email} に送信しました。',
      thank_you: 'Thank You!'
    },
    mementoCodes: MementoCodes.ja(),
    noHotel: 'ホテルなし',
    noPackage: 'パッケージなし',
    packageNotUpdated: 'パッケージを更新できませんでした',
    passwordComplexity: 'パスワードには小文字、大文字、特殊文字、数字が少なくとも一つづつ必要です。',
    payment_term_1: '本日全額を支払い',
    payment_term_2: '本日総額の50%を支払い、後日50％を支払う',
    payment_term_3: '本日総額の3分の1を支払い、後日3分の2の残額を支払う',
    pleaseReview: '入力必須項目です',
    remove: '削除',
    request_packages: 'お問い合わせフォーム',
    required: '入力必須項目です',
    roomQtyError: 'パッケージ数より多い部屋数は選択できません',
    rejectRoomQuantity: 'パッケージ数より多い部屋数は選択できません',
    rejectCountry: 'ご指定の国へは発送できません',
    signUp: '登録する',
    sorryWeCouldNot: '大変申し訳ございません、ご注文を完了できませんでした。引き続き問題が発生する場合は弊社までご連絡ください。',
    submitFormError: 'リクエストを処理できませんでした。恐れ入りますがしばらく後にもう一度操作してください。',
    taxDisclaimer: '金額には、該当するすべての取引税が含まれます',
    today: '本日'
  },
  'zh-CN': {
    cart: Cart.zhCN(),
    cancellation_form: CancellationForm.zhCN(),
    checkout: {
      addOn: CheckoutAddOns.zhCN(),
      address: CheckoutAddress.zhCN(),
      hotelDetails: CheckoutHotelDetails.zhCN(),
      docusign: CheckoutTermsAndConditions.zhCN(),
      payment: CheckoutPayment.zhCN(),
    },
    confirmation: Confirmation.zhCN(),
    creditCardForm: CreditCardForm.zhCN(),
    f1TvCodes: F1TvCodes.zhCN(),
    fanaticCodes: FanaticCodes.zhCN(),
    formPackage: FormPackage.zhCN(),
    h4h: H4H.zhCN(),
    navCart: NavCart.zhCN(),
    orders: Orders.zhCN(),
    opportunity: Opportunity.zhCN(),
    paymentTerms: PaymentTerms.zhCN(),
    roomingLists: RoomingLists.zhCN(),
    shipmentCodes: ShipmentCodes.zhCN(),
    topBar: {
      authentics: 'AUTHENTICS',
      store: 'STORE',
      tickets: '门票',
      hospitality: '礼遇',
      experiences: 'EXPERIENCES',
      sign_in_register: '<i class="icon-account"></i> 登录 <em>或</em> 注册'
    },
    cookie: {
      cookie_consent: '我们通过cookies提供个性化内容、分析流量并收集用户提供的信息，以便就有关活动和服务与其联系。如果继续使用本网站，则表示您同意 <a href="/cookies-policy" target="_blank">我们的 cookies</a>政策。',
      continue: '继续'
    },
    allPurchases: '*所有订单款项以美元计算',
    creditCardNumber: '信用卡卡号',
    currencyDisclaimer: '所选货币的购买将以美元处理。货币金额是基于当前汇率的估计。由于以美元处理，您的银行可能会向您收取额外费用。',
    currencyDisclaimerCharge: '*支付将以选定的货币进行。依据现在的汇率转换为美元。',
    cVV: 'CVV',
    dueDate: '截止{ date }',
    expirationDate: '有效期（月/年）',
    forgotYourPassword: '忘记密码？',
    form: {
      comments: '其它',
      company_name: 'Company Name',
      corporate: '是购买公司团体票吗？',
      email: '电子邮件',
      event: '活动',
      first_name: '名字',
      how_many: '游客数量',
      last_name: '姓氏',
      marketing_email_consent: '本人同意<a href="/privacy-policy" target="/blank">隐私政策</a>，并愿意就本人所选择的活动保持联系',
      next: '下一页',
      password: '密码',
      password_confirmation: '确认密码',
      phone: '手机',
      submit: '提交'
    },
    logIn: '登录',
    logInOrSignUp: '登录或注册以继续',
    messages: {
      close: '关闭',
      questions: '如果您有紧急问题或顾虑，请拨打电话联系我们',
      required: '必填项',
      sent_to_email: '我们已将您的咨询转发给%{brand_name}代表，他将尽快与您联系！确认邮件已发送至您的电子邮箱%{email}。',
      thank_you: 'Thank You!'
    },
    mementoCodes: MementoCodes.zhCN(),
    noHotel: '无酒店',
    noPackage: '无套餐',
    packageNotUpdated: '无法更新套餐',
    passwordComplexity: '密码必须至少包含一个小写字母、一个大写字母、一个特殊字符和一个数字',
    payment_term_1: '立即全额支付',
    payment_term_2: '立即支付50％，之后支付50％',
    payment_term_3: '立即支付1 / 3款项，剩下的分两次支付',
    pleaseReview: '请查看以下字段：',
    remove: '移除',
    request_packages: '在下方请求更多信息',
    required: '必填项',
    roomQtyError: '房间数不得超过套餐数',
    rejectRoomQuantity: '房间数不得超过套餐数',
    rejectCountry: '无效的国家',
    signUp: '注册',
    sorryWeCouldNot: '抱歉，我们无法处理您的订单。如果问题持续出现请联系我们。',
    submitFormError: 'Sorry, we could not submit your request.  Please try again later',
    taxDisclaimer: '金额包括所有适用的交易税在内',
    today: '今天'
  },
  pl: {
    cart: Cart.pl(),
    cancellation_form: CancellationForm.pl(),
    checkout: {
      addOn: CheckoutAddOns.pl(),
      address: CheckoutAddress.pl(),
      hotelDetails: CheckoutHotelDetails.pl(),
      docusign: CheckoutTermsAndConditions.pl(),
      payment: CheckoutPayment.pl(),
    },
    confirmation: Confirmation.pl(),
    creditCardForm: CreditCardForm.pl(),
    f1TvCodes: F1TvCodes.pl(),
    fanaticCodes: FanaticCodes.pl(),
    formPackage: FormPackage.pl(),
    h4h: H4H.pl(),
    navCart: NavCart.pl(),
    orders: Orders.pl(),
    opportunity: Opportunity.pl(),
    paymentTerms: PaymentTerms.pl(),
    roomingLists: RoomingLists.pl(),
    shipmentCodes: ShipmentCodes.pl(),
    topBar: {
      authentics: 'AUTHENTICS',
      store: 'STORE',
      tickets: 'PAKIETY',
      hospitality: 'USŁUGI VIP',
      experiences: 'EXPERIENCES',
      sign_in_register: '<i class="icon-account"></i> ZALOGUJ SIĘ <em>LUB</em> ZAREJESTRUJ'
    },
    cookie: {
      cookie_consent: 'We use cookies to personalize content analyze our traffic and to capture information provided by our visitors to contact them about our events and services. You consent to <a href="/cookies-policy" target="_blank">our cookies</a> if you continue to use this website.',
      continue: 'Kontynuuj'
    },
    allPurchases: '*Wszystkie zakupy będą realizowane w USD',
    creditCardNumber: 'Numer karty kredytowej',
    currencyDisclaimer: '*Zakupy w wybranej walucie będą rozliczane w USD. Podana kwota w walucie jest orientacyjna, wyliczona na podstawie aktualnego kursu wymiany. Ponieważ transakcja będzie rozliczona w USD, bank może obciążyć klienta dodatkowymi opłatami.',
    currencyDisclaimerCharge: '*Płatność zostanie pobrana w wybranej walucie. Przeliczenie należności z USD po aktualnym kursie wymiany',
    cVV: 'Kod CVV',
    dueDate: 'należne {date}',
    expirationDate: 'Data ważności (mm / rr)',
    forgotYourPassword: 'Nie pamiętasz hasła?',
    form: {
      comments: 'Uwagi',
      company_name: 'nazwa firmy',
      corporate: 'Czy zapytanie dotyczy usługi dla firmy?',
      email: 'E-mail',
      event: 'Wydarzenie',
      first_name: 'Imię',
      how_many: 'Liczba podróżnych',
      last_name: 'Nazwisko',
      marketing_email_consent: 'I agree to our <a href=\'/privacy-policy\' target=\'/blank\'>privacy policy</a> and to be contacted regarding my selected event.',
      next: 'następny',
      password: 'hasło',
      password_confirmation: 'potwierdzenie hasła',
      phone: 'Nr telefonu',
      submit: 'Prześlij'
    },
    logIn: 'zaloguj się',
    logInOrSignUp: 'zaloguj się lub zarejestruj, żeby kontynuować',
    messages: {
      close: 'Zamknij',
      questions: 'W razie pytań lub wątpliwości prosimy o kontakt telefoniczny',
      required: 'To pole jest wymagane',
      sent_to_email: 'Twoje zapytanie zostało przekazane przedstawicielowi %{brand_name}, który wkrótce się z Tobą skontaktuje. Potwierdzenie wysłano na Twój adres e-mail, %{email}.',
      thank_you: 'Thank You!'
    },
    mementoCodes: MementoCodes.pl(),
    noHotel: 'Brak hotelu',
    noPackage: 'Brak pakietu',
    packageNotUpdated: 'Nie udało się zaktualizować pakietu',
    passwordComplexity: 'hasło musi zawierać przynajmniej jedną małą literę, jedną wielką literę, jeden znak specjalny i jedną cyfrę',
    payment_term_1: 'Pełna płatność dzisiaj',
    payment_term_2: 'Płatność 50% dzisiaj i 50% w późniejszym terminie',
    payment_term_3: 'Płatności 1/3 dzisiaj i 2 płatności więcej w późniejszym terminie',
    pleaseReview: 'Sprawdź następujące pola:',
    remove: 'Usuń',
    request_packages: 'Prośba o dodatkowe informacje',
    required: 'To pole jest wymagane',
    roomQtyError: 'Liczba pokoi nie może przekraczać liczby pakietów',
    rejectRoomQuantity: 'The number of rooms may not exceed the number of packages.',
    rejectCountry: 'Country is not permitted.',
    signUp: 'zarejestruj się',
    sorryWeCouldNot: 'Przepraszamy, nie mogliśmy zrealizować Twojego zamówienia. Prosimy o kontakt w przypadku dalszego występowania problemu.',
    submitFormError: 'Niestety nie mogliśmy przekazać Twojej prośby. Proszę spróbować później',
    taxDisclaimer: 'kwota zawiera wszystkie należne opłaty transakcyjne',
    today: 'Today'
  }
}
